import { IBiometricService } from '../interfaces/IBiometricService';

/**
 * Web Implementation of Biometric Service
 * Currently a placeholder as browser biometric support (WebAuthn) 
 * requires complex implementation.
 */
export class WebBiometricService implements IBiometricService {
    async isSupported(): Promise<boolean> {
        // Browsers support Public Key Credentials but often require secure context and user interaction
        return !!(window.PublicKeyCredential && window.isSecureContext);
    }

    async isEnrolled(): Promise<boolean> {
        // Placeholder - enrollment check for specific app requires backend/storage check
        return false;
    }

    async authenticate(_reason: string): Promise<{ success: boolean; error?: string }> {
        // WebAuthn implementation would go here
        return { success: false, error: 'Biometric authentication not implemented for web.' };
    }
}
